import { useMemo } from 'react';
import { useSelectedSchoolYear } from '../../../hooks/useSelectedSchoolYear';
import { useTimetables } from '../../Timetable/hooks/useTimetables';
import { findTimetableClassConflicts } from '../Forms/timetableClassConflicts';
import { useTimetableBlocks } from './useTimetableBlocks';

/**
 * Abschnitte, die schon Stundenpläne mit gemeinsamen Klassen enthalten (Altdaten aus der Zeit vor der Prüfung im
 * Formular): Abschnitt-uuid → Namen der betroffenen Stundenpläne.
 */
export const useTimetableBlockClassConflicts = (): Map<string, string[]> => {
  const schoolYear = useSelectedSchoolYear();
  const { timetableBlocks } = useTimetableBlocks(schoolYear?.uuid);
  const { timetables } = useTimetables(schoolYear?.uuid);

  return useMemo(() => {
    const conflicts = new Map<string, string[]>();
    if (!timetableBlocks || !timetables) return conflicts;
    for (const block of timetableBlocks) {
      const { conflicting } = findTimetableClassConflicts(
        block.timetables.map((timetable) => timetable.uuid),
        timetables,
      );
      if (conflicting.length > 0) {
        conflicts.set(
          block.uuid,
          conflicting.map((timetable) => timetable.name),
        );
      }
    }
    return conflicts;
  }, [timetableBlocks, timetables]);
};
